<template>
  <a href="#" class="store_box" @click.prevent="$emit('select', item)">
    <BaseImage src="/static/images/store/store_joker_icon.svg" alt="store joker" />

    <div class="flex-column">
      <p class="title">
        <b v-if="isBonusPhaseEnabledAndValid" class="strikethrough">
          {{ preBonusPhaseNumberOfJokers }}
        </b>

        {{ jokerText }}
      </p>
    </div>

    <div class="flex-row">
      <p class="price">{{ priceText }}</p>

      <i class="fas fa-chevron-right"></i>
    </div>
  </a>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['select']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  bonusPhaseEnabled: {
    type: Boolean,
    default: false,
  },
});

const { proxy } = getCurrentInstance();

const isBonusPhaseEnabledAndValid = computed(() => props.bonusPhaseEnabled && (props.item.multiplier > 0));

const preBonusPhaseNumberOfJokers = computed(() => isBonusPhaseEnabledAndValid.value
  ? Math.floor(props.item.jokers / props.item.multiplier)
  : 0);

const jokerText = computed(() => {
  const totalJokers = props.item.jokers;

  return `${ totalJokers } ${ proxy.$_translate(totalJokers > 1 ? 'page_store_joker_plural' : 'page_store_joker') || '' }`;
});

const priceText = computed(() => `${ props.item.price } ${ props.item.currencyCode }`);
</script>
